import { render, staticRenderFns } from "./test-theme.vue?vue&type=template&id=157a0e10"
import script from "./test-theme.vue?vue&type=script&lang=js"
export * from "./test-theme.vue?vue&type=script&lang=js"
import style0 from "./test-theme.vue?vue&type=style&index=0&id=157a0e10&prod&lang=scss"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports